import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/auth-context";
import { useAuthGuard } from "@/hooks/use-auth-guard";

export const RequireAuthNoCompany: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { selectedSubscriptionId, selectedCompanyId } = useAuth();
  const location = useLocation();
  const { isValidating, isValid, isReady, shouldRedirect, redirectTo } = useAuthGuard();

  if (isValidating || !isReady) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="flex flex-col items-center space-y-4">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          <p className="text-sm text-muted-foreground">
            Validando autenticación...
          </p>
        </div>
      </div>
    );
  }

  if (shouldRedirect) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  if (isValid && !selectedSubscriptionId) {
    return <Navigate to="/select-subscription" state={{ from: location }} replace />;
  }

  if (isValid && selectedCompanyId) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
